import circularLogo from "@circle-assets/images/circular-logo@2x.png";
import { Typography } from "@circleco/compass/components/Typography";

import { t } from "@/i18n-js/instance";

export const OnboardingHeader = () => (
  <header className="flex shrink-0 items-center gap-2.5 px-6 py-4">
    <img
      src={circularLogo}
      alt={t("circle_ai.onboarding.logo_alt")}
      className="size-7 rounded-md"
    />
    <Typography variant="label-md" color="primary" component="span">
      {t("circle_ai.onboarding.header_title")}
    </Typography>
  </header>
);
